import React from "react"
import useIsInViewport from "use-is-in-viewport"
import Image from "../components/image"
import IntroVideo1 from "../video/home/covid-intro-fade.mp4"
import IntroVideo2 from "../video/home/covid-fade.mp4"

export default function ScrollSlideshow({ contentRef }) {
  const [isSlide2InViewport, slide2] = useIsInViewport()
  const [isSlide2Centered, slide2Centered] = useIsInViewport({
    modBottom: "-25%",
  })
  const [isSlide3InViewport, slide3] = useIsInViewport()
  const [isSlide3Centered, slide3Centered] = useIsInViewport({
    modBottom: "-25%",
  })
  const [isSlide4InViewport, slide4] = useIsInViewport()
  const [isSlide4Centered, slide4Centered] = useIsInViewport({
    modBottom: "-25%",
  })
  const [isSlide5InViewport, slide5] = useIsInViewport()
  const [isSlide5Centered, slide5Centered] = useIsInViewport({
    modBottom: "-25%",
  })
  const [isContentInViewport, wrappedTargetRef] = useIsInViewport({
    target: contentRef,
  })

  return (
    <div className="scroll-slideshow" ref={wrappedTargetRef}>
      <div className="scroll-slideshow__icon" />
      <div
        className={
          isContentInViewport
            ? "scroll-slideshow__images"
            : "scroll-slideshow__images scroll-slideshow__images--hidden"
        }
      >
        <div
          className={
            isSlide5InViewport
              ? "scroll-slideshow__images__inner scroll-slideshow__images__inner--opaque"
              : "scroll-slideshow__images__inner"
          }
        >
          <video
            src={IntroVideo1}
            muted
            loop
            playsInline
            autoPlay={true}
            className="visible util__desktop-only"
          ></video>
          <Image
            path="home/gloves.jpg"
            alt="A doctor putting on full-body personal protective equipment"
            className="visible util__mobile-only"
          />
          <Image
            path="home/circles.jpg"
            alt="An aerial view of a park with groups of people sitting in circles spaced six feet apart"
            className={isSlide2InViewport ? "visible" : null}
          />
          <video
            src={IntroVideo2}
            muted
            loop
            playsInline
            autoPlay={true}
            className={
              isSlide3InViewport
                ? "visible util__desktop-only"
                : "util__desktop-only"
            }
          ></video>
          <Image
            path="home/covid.jpg"
            alt="Many people walking across a busy pedestrian bridge and wearing masks"
            className={
              isSlide3InViewport
                ? "visible util__mobile-only"
                : "util__mobile-only"
            }
          />
          <Image
            path="home/theatre.jpg"
            alt="A worker in hazmat gear sanitizing a theatre"
            className={isSlide4InViewport ? "visible" : null}
          />
          <Image
            path="home/blue.jpg"
            alt="A solid blue background"
            className={isSlide5InViewport ? "visible" : null}
          />
        </div>
      </div>
      <ul>
        <li
          className={
            isSlide2InViewport
              ? "scroll-slideshow__slide scroll-slideshow__slide--hidden"
              : "scroll-slideshow__slide"
          }
        >
          <div className="scroll-slideshow__slide__intro">
            <h1>
              A <br />Year <br />Like <br />No <br />Other
            </h1>
            <h2>IMF Annual Report 2020</h2>
          </div>
        </li>
        <li
          className={
            isSlide3InViewport
              ? "scroll-slideshow__slide scroll-slideshow__slide--hidden"
              : "scroll-slideshow__slide"
          }
          ref={slide2}
        >
          <p ref={slide2Centered}>
            The global economy is facing a{" "}
            <em className={isSlide2Centered ? "highlight" : null}>
              deep recession
            </em>{" "}
            with the ongoing impact of COVID-19.
          </p>
        </li>
        <li
          className={
            isSlide4InViewport
              ? "scroll-slideshow__slide scroll-slideshow__slide--hidden"
              : "scroll-slideshow__slide"
          }
          ref={slide3}
        >
          <p ref={slide3Centered}>
            <em className={isSlide3Centered ? "highlight" : null}>
              Uncertainty remains
            </em>{" "}
            around the outlook, alongside long-term forces that shape and
            influence countries’ response to the virus and the recovery.
          </p>
        </li>
        <li
          className={
            isSlide5InViewport
              ? "scroll-slideshow__slide scroll-slideshow__slide--hidden"
              : "scroll-slideshow__slide"
          }
          ref={slide4}
        >
          <p ref={slide4Centered}>
            People all over the world have seen{" "}
            <em className={isSlide4Centered ? "highlight" : null}>
              profound changes in their lives:{" "}
            </em>{" "}
            economic recession, unemployment, climate change, technology and the
            automation of jobs, the rise of digital currencies, lower returns on
            their savings, and rising inequality and debt.
          </p>
        </li>
        <li className="scroll-slideshow__slide" ref={slide5}>
          <p ref={slide5Centered}>
            These ongoing global forces and the current crisis can offer{" "}
            <em className={isSlide5Centered ? "highlight" : null}>
              opportunities to build a better future for everyone.
            </em>{" "}
            Working together in good faith and with shared goals can yield
            solutions to our most pressing problems, restore leadership and
            trust in institutions, and create a recovery that builds a global
            economy to serve everyone.
          </p>
        </li>
      </ul>
    </div>
  )
}
